import React, { useContext } from 'react';
import { ILoqateAddress, LoqateModal } from './LoqateModal';
import ConnectedFormContext from '../../components/Context/ConnectedFormContext';
import { useDispatch } from 'react-redux';

export const ConnectedLoqateModal = ({
  addressDataid = 'address',
  companyDataid,
  disabled = false,
}: {
  addressDataid?: string;
  companyDataid?: string;
  disabled?: boolean;
}) => {
  const dispatch = useDispatch();
  const connectedForm = useContext(ConnectedFormContext);
  const onSubmitHandler = (address: Readonly<ILoqateAddress>) => {
    // Context
    if (companyDataid && address?.company) {
      dispatch(connectedForm.change(companyDataid, address?.company));
    }

    if (addressDataid) {
      /* Destructure address to exclude "company" field because we don't want this to be sent back to the services
      in the graphQL, doing so prevents the order from saving because there is no "Company" field
      in an address currently. This is mapped to a different field
      or combined with address lines 1 depending on the exact use case.
      */
      const { company, ...addressWithoutCompany } = address;
      dispatch(connectedForm.change(addressDataid, addressWithoutCompany));
    }
  };

  return <LoqateModal disabled={disabled} onSubmit={onSubmitHandler} hasSeparateCompanyField={!!companyDataid} />;
};
